<template>
  <div class="cont">

    <div class="flex-container" v-show="showProviders && !providerEdit" :class="{'fade-in' : fadeIn}">
      <button @click.prevent="addProvider()" class="btn blue hidden-xs">Ajouter un Prestataire</button>
      <button @click.prevent="addProvider()" class="btn blue btn-block visible-xs">Ajouter un Prestataire</button>
      <div class="flex-item hidden-xs" style="margin-top: .5rem">
        <span class="customSpan">Ou</span>
      </div>
      <button @click.prevent="addSupport()" class="btn blue hidden-xs" >Ajouter un renfort</button>
      <button @click.prevent="addSupport()" class="btn blue btn-block visible-xs" style="margin-top: .5rem" >Ajouter un renfort</button>
    </div>

    <div style="margin-top: .5rem" >
      <v-select class="fade-in" v-show="isProvider" name="user_id" title="Prestataires" :items="users" v-model="current.userId" attributeName="fullName" @clearError="clearError" placeholder="Choisissez un prestataire"></v-select>
      <v-select class="fade-in" v-show="isSupport"  name="renfort_id" title="Renforts" :items="renforts" v-model="current.renfortId" attributeName="fullName" @clearError="clearError" placeholder="Choisissez un renfort"></v-select>
    </div>
    <div class="alert alert-danger"  v-show="error!=''">{{error}}</div>
    <button v-show="isProvider || isSupport" @click.prevent="addIt(isProvider ? current.userId : current.renfortId )" class="btn btn-block green fade-in" style="margin-bottom: .5rem">Ajouter</button>

    <ul class="list-group fade-in" v-show="Object.keys(selected).length != 0">
      <li class="list-group-item fade-in">
        {{ checkType }}
        <span class="bold">{{ fullname }}
          <span class="pull-right"><i class="fas fa-times pointer" @click="removeIt()"></i></span>
        </span>
      </li>
    </ul>

    <p class="text-center alert alert-danger" v-if="errors[name]">{{ errors[name][0] }}</p>

  </div>
</template>
<script>
export default {
name: 'calProviders',
props: ['users', 'renforts', 'current', 'errors', 'name', 'isEdited', 'quickCreate'],
  data() {
    return {
      selected: {},
      isProvider: false,
      isSupport: false,
      isTypeProvider: false,
      fadeIn: false,
      providerEdit: false,
      error: ''
    }
  },
  mounted() {
    this.getSelected(this.current)

    if(this.users.length+this.renforts.length==1){//if solo select user
      this.addProvider()
      this.current.userId=this.users[0].id
      this.addIt(this.users[0].id)
    }
    this.isEdited ? this.providerEdit = this.isEdited : this.providerEdit = this.quickCreate
  },
  watch:{
    current: {
      deep: true,
      handler(){
        if(!this.isProvider && !this.isSupport){
          this.getSelected(this.current)//force reload of selected encadrant when selecting other booking/event
        }
      }
    }
  },
  computed: {
    fullname() {
      return this.selected.name + ' ' + this.getLastName(this.selected)
    },
    checkType() {
      if (this.current.userId) {
        this.isTypeProvider = true
        return 'Prestataire : '
      }

      this.isTypeProvider = false
      return 'Renfort : '
    },
    showProviders() {
      return Object.keys(this.selected).length === 0
    }
  },
  methods: {
    getSelected(current_user) {
      if (current_user.userId) {
        this.selected = this.users.find(user => user.id === parseInt(current_user.userId))
      } else if (current_user.renfortId) {
        this.selected = this.renforts.find(renfort => renfort.id === parseInt(current_user.renfortId))
      } else {
        this.selected = {}
      }
    },
    addProvider() {
      this.isProvider = !this.isProvider
      this.isSupport = false
    },
    addSupport() {
      this.isProvider = false
      this.isSupport = !this.isSupport
    },
    addIt(id) {
      if(id!="")
      {
        this.error =""
        const selectedUser = this.isProvider ? this.users.find(user => user.id === id) : this.renforts.find(renfort => renfort.id === id)
        this.isProvider ? this.isTypeProvider = true : false
        this.selected = selectedUser
        this.isProvider ? this.isProvider = !this.isProvider : this.isSupport = !this.isSupport
        this.$emit('input')
      }
      else
      {
        this.error ="Séléctionner un prestataire ou un renfort avant de valider"
      }
    },
    removeIt() {
      this.selected = {}
      this.current.renfortId = ''
      this.current.userId = ''
      this.isTypeProvider = false
      this.fadeIn = true
      this.providerEdit = false
      this.$emit('input')
    },
    clearError(e){
      this.$delete(this.errors, e)
    },
    getLastName(data){
      return this.selected.lastName ? this.selected.lastName : this.selected.lastname;
    }
  }
};
</script>
<style>
.cont {
  padding: .5rem .5rem 0;
  border: .5px solid #E5E5E5;
  margin-bottom: 13px;
}
.customSpan {
  font-size: 120%;
}
.list-group {
  margin-bottom: 10px!important;
}
.pointer {
  cursor: pointer;
}

.flex-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap
}

</style>


